export class HttpError extends Error {
  public readonly status: number;

  constructor(status: number, statusText: string, uri: string) {
    super(`${status} ${statusText}: ${uri}`);
    this.status = status;
    this.name = 'HttpError';
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
